import jsPDF from "jspdf";
import dayjs from "dayjs";
import laiSenBale from "./pic/a2.jpg";
import arabicToThai from "../../../../hook/arabicToThai";

export async function exportNotifyGuarantor28New(
    dataTabelB,
    selectedContract,
    countBatch,
    targetWindow
) {

    const [convertToThaiNumerals, toThaiWord, numberToThaiText] = arabicToThai();

    const doc = new jsPDF('p', 'mm', 'a4');

    dataTabelB.forEach((item, index) => {

        let addCompany1, T1, A1, J1;
        J1 = `จ. ${item?.PROVDES}`;
        if (selectedContract?.key === "vsfhp") {
            addCompany1 = "บริษัท วัน ลิสซิ่ง จำกัด";
        } else {
            addCompany1 = "บริษัท วัน มันนี่ จำกัด";
        }
        if (item?.PROVCOD === "01") {
            T1 = `แขวง ${item?.TUMB}`;
            A1 = `เขต ${item?.AUMPDES}`;
        } else {
            T1 = `ต.${item?.TUMB}`;
            A1 = `อ.${item?.AUMPDES}`;
        }

        if (index > 0) doc.addPage();

        let y = 20; // ตำแหน่ง Y เริ่มต้น
        const lineHeight = 8; // ระยะห่างบรรทัด (สำคัญเพื่อให้ดูเหมือนเอกสารจริง)

        doc.setFont('THSarabunNew', 'normal');
        doc.setFontSize(14);

        // --- ส่วนหัว (ชื่อบริษัทและที่อยู่) ---
        doc.setFont('THSarabunNew', 'normal');


        const address = `
                    ชื่อลูกค้า:     ${item.SNAM + item.NAME1 + ' ' + item.NAME2} (คนค้ำ ${item?.GARNO}) (${item?.CONTNO})
                    ที่อยู่:          ${item?.ADDR1} 
                                    ${T1} ${A1} ${J1} ${item?.ZIP}
                    เบอร์โทร:    ${item?.TELP}
                                    (${dayjs(item.RoundDate).format('DD/MM/YYYY')})
        `;
        doc.text(address, 5, y);
        y += 67;

        // --- วันที่ ---
        const dataNow = dayjs(item.RoundDate).format('DD/MM/YYYY'); // เปลี่ยนเป็นวันที่ยึด

        doc.text(`วันที่ ${dataNow}`, 160, y, { align: 'right' });
        y += 10;


        const s1 = `
        เรื่อง แจ้งให้ชำระค่าเช่าซื้อที่ค้างชำระ สัญญาเช่าซื้อเลขที่ (${item?.CONTNO})
        `;
        doc.text(s1, 5, y);
        y += 7;

        const s2 = `
        เรียน ${item.SNAM + item.NAME1 + ' ' + item.NAME2} 
        `;
        doc.text(s2, 5, y);
        y += 22;

        // --- เนื้อหา Paragraph 1 ---
        doc.setFont('THSarabunNew', 'normal');

        doc.text('ตามที่ท่านได้ตกลงทำสัญญาค้ำประกันการเช่าซื้อรถยนต์ยี่ห้อ', 25, y);
        doc.setFont("THSarabunNew", "bold");
        doc.text(`${item?.TYPE}`, 110, y);

        doc.setFont('THSarabunNew', 'normal');
        doc.text(' รุ่น ', 135, y);

        // หมายเลขเครื่อง
        doc.setFont("THSarabunNew", "bold");
        doc.text(`${item?.MODEL}`, 150, y);

        y += lineHeight;

        doc.setFont('THSarabunNew', 'normal');
        doc.text(`สี `, 15, y);

        doc.setFont("THSarabunNew", "bold");
        doc.text(`${item?.COLOR}`, 20, y);

        doc.setFont('THSarabunNew', 'normal');
        doc.text(`เลขตัวถัง `, 55, y);
        doc.setFont("THSarabunNew", "bold");
        doc.text(`${item?.STRNO}`, 75, y);

        doc.setFont('THSarabunNew', 'normal');
        doc.text(`เลขเครื่อง `, 115, y);
        doc.setFont("THSarabunNew", "bold");
        doc.text(`${item?.ENGNO}`, 140, y);

        y += lineHeight;

        doc.setFont('THSarabunNew', 'normal');
        doc.text(`ทะเบียน `, 15, y);

        doc.setFont("THSarabunNew", "bold");
        doc.text(`${item?.REGNO + ' ' + item.DORECV}`, 30, y);

        doc.setFont('THSarabunNew', 'normal');
        doc.text(`ระหว่าง ${item.BSNAM + item.BNAME1 + ' ' + item.BNAME2} `, 70, y);
        doc.text(`ผู้เช่าซื้อกับ บริษัท วัน ลิสซิ่ง จำกัด `, 140, y);
        y += lineHeight;

        doc.text(`ผู้ให้เช่าซื้อตามสัญญาเช่าซื้อฉบับลงวันที่  `, 15, y);
        doc.setFont("THSarabunNew", "bold");
        doc.text(`${dayjs(item.SDATE).format('DD/MM/YYYY')}`, 70, y);

        doc.setFont('THSarabunNew', 'normal');
        doc.text(`รายละเอียดที่ท่านทราบดีอยู่แล้วนั้น บัดนี้ผู้เช่าซื้อได้ปฏิบัติผิดสัญญา `, 95, y);

        y += lineHeight;

        const amount = Number(item?.EXP_AMT ?? 0).toLocaleString('th-TH', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
        const amountThaiText = numberToThaiText(amount);

        // doc.setFont("THSarabunNew", "bold");
        doc.text(`โดยค้างชำระค่าเช่าซื้อ งวดที่ ${item.EXP_FRM + ' - ' + item.EXP_TO}`, 15, y);
        doc.text(`ซึ่งกำหนดชำระ`, 65, y);
        doc.setFont("THSarabunNew", "bold");
        doc.text(`${dayjs(item.FirstUnpaidDate).format('DD/MM/YYYY')}`, 90, y);
        doc.setFont('THSarabunNew', 'normal');
        doc.text(`จำนวน ${item.EXP_PRD} งวด ติดต่อกันเป็นจำนวนเงิน`, 110, y);
        doc.setFont("THSarabunNew", "bold");
        doc.text(`${amount} บาท`, 170, y);
        doc.setFont('THSarabunNew', 'normal');

        y += lineHeight;


        doc.setFont('THSarabunNew', 'bold');
        doc.text(`${amountThaiText}  (รวมภาษีมูลค่าเพิ่ม)`, 15, y);

        doc.setFont("THSarabunNew", "normal");
        doc.text(`ส่วนค่าเบี้ยปรับตามกฎหมาย พร้อมค่าใช้จ่ายในการติดตามอื่นๆ `, 105, y);
        y += lineHeight;

        doc.setFont('THSarabunNew', 'normal');
        doc.text(`ขอให้ท่านชำระหนี้ที่ค้างทั้งหมดให้แล้วเสร็จภายใน   7   วัน  นับจากที่ท่านได้รับหนังสือฉบับนี้`, 15, y);

        // doc.setFont("THSarabunNew", "bold");

        y += lineHeight;
        y += lineHeight;

        doc.text(`หากท่านเพิกเฉยระยะเวลาตามหนังสือ ท่านไม่ชำระหนี้ผู้ให้เช่าซื้อมีความจำเป็นที่จะต้อง ดำเนินตามกฎหมายต่อไป`, 15, y);

        y += lineHeight;
        y += lineHeight;


        doc.text(`จึงเรียนมาเพื่อโปรดดำเนินการด่วน`, 30, y);




        // y += 14;

        // --- ส่วนลงนาม (จัดชิดขวา) ---
        // doc.text('ขอแสดงความนับถือ', 130, y,);
        y += 20; // เว้นระยะสำหรับลายเซ็น

        const signatureImg = laiSenBale;  // ใส่ Base64 ของรูปคุณ

        // const offset = 10;
        doc.addImage(signatureImg, 'PNG', 155, 215, 30, 15);

        doc.text('ลงชื่อ....................................', 150, y);
        y += 7;
        doc.text('ผู้ออกจดหมาย', 159, y);

        y += lineHeight;
        y += lineHeight;
        y += lineHeight;
        y += lineHeight;

        doc.text('- หากท่านได้นำเงินดังกล่าวไปชำระก่อนได้รับจดหมายฉบับนี้ ทางบริษัทต้องขออภัยมา ณ ที่นี้ด้วย', 15, y);
        // y += 7;

        // doc.autoPrint();
        // window.open(doc.output('bloburl'));
    });
    // ฝังคำสั่ง print ลงใน PDF

    doc.autoPrint();
    return doc.output("bloburl");
}